interface EnviromentVariables {
  IS_DEV: boolean;
  API_URL: string;
  SEZNAM_API_KEY: string;
}

export const env: EnviromentVariables = {
  IS_DEV: process.env.NODE_ENV === 'development',
  API_URL: process.env.REACT_APP_API_URL as string,
  SEZNAM_API_KEY: process.env.REACT_APP_SEZNAM_API_KEY as string
};
